import { useCallback } from "react";
import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  CloseButton,
  RenderProps,
  ToastProps,
  useToast,
} from "@chakra-ui/react";

/**
 * Chakra ui toast custom component to match the design
 */
export default function useAlert(): (options: ToastProps) => void {
  const toast = useToast();

  return useCallback(
    ({ title, description, variant, status = "error", position = "bottom-left", duration = 3000 }) => {
      toast({
        duration,
        position,
        render: ({ onClose }: RenderProps) => (
          <Alert status={status} variant={variant}>
            <AlertIcon />
            <Box>
              <AlertTitle>{title}</AlertTitle>
              <AlertDescription>{description}</AlertDescription>
            </Box>
            <CloseButton onClick={onClose} size="sm" alignSelf="flex-start" position="absolute" insetEnd="2" top="2" />
          </Alert>
        ),
      });
    },
    [toast]
  );
};
